import type { RouterState } from "@tanstack/react-router";
import { last } from "remeda";

/** @returns The current route's ID, suitable to eg. use as a `{ to: routeId }` link parameter */
export function getCurrentRouteId(state: RouterState) {
    const match = last(state.matches)!;
    return match.fullPath as string;
}
